export default "__VITE_PUBLIC_ASSET__06a46d9b__"